import React from "react";

const HANDLE = "@sunstatecollective";

// Social account links — all three platforms use the same handle.
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/sunstatecollective/",
  tiktok: "https://www.tiktok.com/@sunstatecollective",
  facebook: "https://www.facebook.com/people/Sunstate-Collective/61589388053312/",
};

const IconInstagram = (props) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none"
    stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
    strokeLinejoin="round" aria-hidden="true" {...props}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

const IconFacebook = (props) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"
    aria-hidden="true" {...props}>
    <path d="M13.5 22v-8h2.7l.4-3.1h-3.1V8.9c0-.9.3-1.5 1.6-1.5h1.7V4.6c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1v2.3H7.6V14h2.7v8h3.2z" />
  </svg>
);

// Lucide doesn't have a TikTok icon — using the official simple-icons path.
const IconTikTok = (props) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"
    aria-hidden="true" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.9a8.16 8.16 0 0 0 4.77 1.52V7a4.85 4.85 0 0 1-1.84-.31z"/>
  </svg>
);

/**
 * Inline social icons strip — black, minimal, with handle.
 * Use `variant="inline"` (default) for a clean horizontal strip with the handle,
 * or `variant="icons-only"` for compact icon-only display (e.g. footer).
 *
 * NOTE on click handler: some hosting environments (incl. our preview) inject a
 * Cross-Origin-Opener-Policy header which causes Safari to block plain
 * `target="_blank"` + `rel="noopener"` links to social sites. We bypass this by
 * opening the link programmatically via window.open without `noopener`, with a
 * same-tab navigation fallback if popups are blocked.
 */
const openExternal = (e, href) => {
  e.preventDefault();
  const win = window.open(href, "_blank");
  if (!win || win.closed || typeof win.closed === "undefined") {
    // Popup blocked or COOP blocked — fall back to same-tab nav.
    window.location.href = href;
  }
};

export const Social = ({ variant = "inline", className = "", testId = "social-strip" }) => {
  const links = [
    { key: "instagram", href: SOCIAL_LINKS.instagram, label: "Instagram", Icon: IconInstagram },
    { key: "tiktok", href: SOCIAL_LINKS.tiktok, label: "TikTok", Icon: IconTikTok },
    { key: "facebook", href: SOCIAL_LINKS.facebook, label: "Facebook", Icon: IconFacebook },
  ];

  return (
    <div
      className={`sc-social sc-social-${variant} ${className}`}
      data-testid={testId}
    >
      {variant === "inline" && (
        <span className="sc-social-handle">{HANDLE}</span>
      )}
      <div className="sc-social-icons">
        {links.map(({ key, href, label, Icon }) => (
          <a
            key={key}
            href={href}
            onClick={(e) => openExternal(e, href)}
            aria-label={`${label} — ${HANDLE}`}
            className="sc-social-link"
            data-testid={`social-link-${key}`}
          >
            <Icon />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Social;
